import { createSelector } from 'reselect/lib/index';
import { get } from 'lodash';

import { DEPENDENT_FORM_STEPS } from './progress.actions';

const selectDependentFormState = state => get(state, 'dependentForm');

const selectPersonalInfoState = createSelector(
  selectDependentFormState,
  state => get(state, 'personalInfo'),
);

const selectGeneralInfoState = createSelector(
  selectDependentFormState,
  state => get(state, 'generalInfo'),
);

const selectDocumentsCompletionState = createSelector(
  selectDependentFormState,
  state => get(state, 'documentsCompletion'),
);

const selectDocumentsUploadState = createSelector(
  selectDependentFormState,
  state => get(state, 'documentsUpload'),
);

const selectDocumentsDeleteState = createSelector(
  selectDependentFormState,
  state => get(state, 'documentsDelete'),
);

const selectDocumentsListState = createSelector(
  selectDependentFormState,
  state => get(state, 'documentsList'),
);

const selectRelationState = createSelector(
  selectDependentFormState,
  state => get(state, 'relationship'),
);

const selectProgressState = createSelector(
  selectDependentFormState,
  state => get(state, 'progress'),
);

const selectGuardianListState = createSelector(
  selectDependentFormState,
  state => get(state, 'assignedGuardianList'),
);

export const selectDependentGuardianList = createSelector(
  selectGuardianListState,
  state => get(state, 'list', []),
);

export const selectDependentGuardianListLoading = createSelector(
  selectGuardianListState,
  state => get(state, 'sending', false),
);

export const selectDependentDocumentList = createSelector(
  selectDocumentsListState,
  state => get(state, 'list', []),
);

export const selectDependentDocumentListLoading = createSelector(
  selectDocumentsListState,
  state => get(state, 'sending', false),
);

export const selectDependentFormDependent = createSelector(
  selectDependentFormState,
  state => get(state, 'assignment.dependent', {}),
);

export const selectDependentPhoneNumberCountryCode = createSelector(
  selectDependentFormDependent,
  state => get(state, 'phoneNumberCountryCode'),
);

export const selectDependentPhoneNumberCountryIsoCode = createSelector(
  selectDependentFormDependent,
  state => get(state, 'phoneNumberCountryIsoCode'),
);

export const selectDependentFormRegistrationSteps = createSelector(
  selectDependentFormState,
  state => get(state, 'progress.registrationSteps'),
);
export const selectDependentFormProgressMetadata = createSelector(
  selectDependentFormState,
  state => get(state, 'progress.metadata'),
);

export const selectDependentFormSubmitRedirect = createSelector(
  selectDependentFormState,
  state => get(state, 'progress.submitRedirect'),
);

export const selectDependentFormPending = createSelector(
  selectPersonalInfoState,
  selectGeneralInfoState,
  selectDocumentsCompletionState,
  selectDocumentsUploadState,
  selectDocumentsDeleteState,
  selectDocumentsListState,
  selectRelationState,
  (...states) => states.some(state => state.sending),
);

export const selectDependentFormValidating = createSelector(
  selectProgressState,
  state => get(state, 'validating'),
);

export const selectDependentFormRole = createSelector(
  selectProgressState,
  state => get(state, 'role'),
);
export const selectDependentFormCurrentStep = createSelector(
  selectProgressState,
  state => get(state, 'currentStep'),
);

export const selectDependentFormUserData = createSelector(
  selectProgressState,
  state => get(state, 'dependent'),
);

export const selectDependentFormAssigmentId = createSelector(
  selectProgressState,
  state => get(state, 'id'),
);

export const selectDependentFormIsCareUserCreator = createSelector(
  selectProgressState,
  state => get(state, 'careUserCreator'),
);

export const selectDependentFormIsBackDisabled = createSelector(
  selectDependentFormIsCareUserCreator,
  selectDependentFormCurrentStep,
  (isCareCreator, step) => {
    return isCareCreator === false || step === DEPENDENT_FORM_STEPS.GENERAL;
  },
);

export const selectDependentFormCompleted = createSelector(
  selectDependentFormCurrentStep,
  step =>
    [DEPENDENT_FORM_STEPS.COMPLETE, DEPENDENT_FORM_STEPS.USER_EXIST].includes(
      step,
    ),
);

export const selectDependentFormPersonalInfoErrors = createSelector(
  selectPersonalInfoState,
  state => get(state, 'error'),
);

export const selectDependentFormGeneralInfoErrors = createSelector(
  selectGeneralInfoState,
  state => get(state, 'error'),
);



// WEBPACK FOOTER //
// ./src/redux/dependentForm/selectors.js